import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooterButtons,
  ModalHeader,
} from '@televet/kibble-ui/build/components/Modal';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';
import useClinicUser from 'shared/hooks/useClinicUser';
import { STATUSES, useCustomToast } from 'shared/hooks/useCustomToast';
import { ClinicSettingsTeamUserFragment, useDeleteClinicSettingsTeamUserMutation } from 'shared/types/graphql';
import { getUserFullName } from 'shared/utils';

interface IDeleteUserModal {
  onConfirmDeleteUser?: () => void;
  user?: ClinicSettingsTeamUserFragment;
  isOpen: boolean;
  onClose: () => void;
}

const DeleteUserModal = ({ onConfirmDeleteUser, user, isOpen, onClose }: IDeleteUserModal): JSX.Element | null => {
  const { currentClinicId, currentClinic } = useClinicUser();
  const [deleteTeamSettingUser, { loading }] = useDeleteClinicSettingsTeamUserMutation();
  const { toastMessagePop } = useCustomToast();

  const deleteUser = async (): Promise<void> => {
    if (!user?.id || !currentClinicId) return;
    await deleteTeamSettingUser({
      variables: {
        data: {
          clinicId: currentClinicId,
          userId: user.id,
        },
      },
    });
    if (!onConfirmDeleteUser) return;
    toastMessagePop('Team member has been removed', STATUSES.success);
    onConfirmDeleteUser();
    onClose();
  };

  if (!user) {
    return null;
  }

  const { firstName, lastName, namePrefix, nameSuffix } = user;

  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalHeader>
        Are you sure you want to delete <br /> this user?
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>
          {getUserFullName({ firstName, lastName, namePrefix, nameSuffix })} will no longer have access to{' '}
          {currentClinic?.name || 'the clinic'} in Flow.
        </Text>
      </ModalBody>
      <ModalFooterButtons
        onCancel={onClose}
        onSubmit={deleteUser}
        isLoading={loading}
        submitText="Delete User"
        isDestructive={true}
      />
    </Modal>
  );
};

export default DeleteUserModal;
